import React, {
	useEffect, useState
}from "react"
import {
	Input, Modal, Form, Select, Checkbox, Spin, Empty
}from "antd"
import {
	reOrgActions
}from '../ReOrgs/actions'
import 'antd/lib/date-picker/style/index.css'
import "antd/lib/spin/style/index.css"
import "antd/lib/empty/style/index.css"
import i18nGlobal from "../../../localization"
import i18n from "../localization"
import {
	useDispatch, useSelector
}from "react-redux"
import Notifications from "../../../helpers/Notifications"
import {
	CustomSelect
}from "../../../components/CustomSelect"
import {
	CustomInput
}from "../../../components/CustomInput"
import CustomButton from "../../../components/ButtonCustom"
import {
	useDebounce
}from "use-lodash-debounce"
import "../style.css"
const { Option } = Select

const ReOrgCreateUpdateForm = (props) => {
	const dispatch = useDispatch()
	const isRu = useSelector(state => state.globalReducer.isRu)
	const { visible, setVisible, setRecord, record, create, update, reOrg } = props
	const [form] = Form.useForm()
	const { changeOrgUnitLoading } = useSelector((state) => state.managementReducer)
	const { reOrgTypes, reOrgStatusTypes, orgChanged, isSending, minReOrgByNameOrUNP, minReOrgSending } = useSelector((state) => state.reOrgReducer)
	const [parentName, setParentName] = useState("")
	const [parentInit, setParentInit] = useState([])
	const [institutionName, setInstitutionName] = useState("")
	const [institutionInit, setInstitutionInit] = useState("")
	const searchParent = useDebounce(parentName, 500)
	const searchInstitution = useDebounce(institutionName, 500)

	useEffect(() => {
		dispatch(reOrgActions.clearMinReOrgByNameOrUNP())
		return () => {
			dispatch(reOrgActions.clearMinReOrgByNameOrUNP())
		}
	}, [])

	useEffect(() => {
		form.resetFields()
		if (record){
			setParentInit(record.parent ? [record.parent] : [])
			setInstitutionInit(record.institution ? [record.institution] : [])
			form.setFieldsValue({
				fullName           : record.fullName?.trim(),
				fullNameBel        : record.fullNameBel?.trim(),
				institutionOrg     : record.institution?.id,
				isEnteredManually  : record.isEnteredManually,
				parentOrg          : record.parent?.id,
				reOrgCreator			 : record.reOrgCreator?.fullName,
				reOrgStatusType    : record.reOrgStatusType?.id,
				reOrgType          : record.reOrgType?.id,
				shortName          : record.shortName?.trim(),
				shortNameBel       : record.shortNameBel?.trim(),
				unp                : record.unp
			})
		}
	}, [record, form])

	useEffect(() => {
		dispatch(reOrgActions.getTypesStatuses())
	}, [])

	function handleCancel(){
		form.resetFields()
		setVisible(false)
		setRecord(null)
		setParentInit([])
		setParentName("")
		setInstitutionInit([])
		setInstitutionName("")
		dispatch(reOrgActions.clearMinReOrgByNameOrUNP())
	}

	function getReOrgOptions(array, name){
		return array?.length ? array?.map((org, index) => {
			return (
				<Option
					key={ `${name}_${index}` }
					title={ isRu ? org.fullName : (org.fullNameBel ? org.fullNameBel : org.fullName) }
					value={ org.id }
				>
					{ isRu ? org.fullName : (org.fullNameBel ? org.fullNameBel : org.fullName) }
				</Option>
			)
		}) : null
	}

	useEffect(() => {
		if (searchParent?.trim())
			getReOrgsByName(searchParent.trim())
	}, [searchParent])

	useEffect(() => {
		if (searchInstitution?.trim())
			getReOrgsByName(searchInstitution.trim())
	}, [searchInstitution])

	function getReOrgsByName(value){
		dispatch(reOrgActions.getMinReOrgByNameOrUNP({
			name              : value,
			"orgTypeCodes[0]" : 1,
			"orgTypeCodes[1]" : 3,
			"orgTypeCodes[2]" : 4,
			pageSize          : 20
		}))
	}

	useEffect(() => {
		if (orgChanged)
			handleCancel()
	}, [orgChanged])

	const onFinish = values => {
		const updateValues = {
			fullName          : values.fullName?.trim() ?? null,
			fullNameBel       : values.fullNameBel?.trim() ?? null,
			id                : record?.id,
			institutionId     : values.institutionOrg ?? null,
			isEnteredManually : values.isEnteredManually ?? false,
			parentId          : values.parentOrg ?? null,
			reOrgStatusType   : values.reOrgStatusType,
			reOrgType         : values.reOrgType,
			shortName         : values.shortName?.trim() ?? null,
			shortNameBel      : values.shortNameBel?.trim() ?? null,
			unp               : values.unp ?? null
		}
		const previousValues = {
			fullName          : record?.fullName?.trim() ?? null,
			fullNameBel       : record?.fullNameBel?.trim() ?? null,
			id                : record?.id,
			institutionId     : record?.institution?.id ?? null, 
			isEnteredManually : record?.isEnteredManually ?? false,
			parentId          : record?.parent?.id ?? null,
			reOrgStatusType   : record?.reOrgStatusType?.id,
			reOrgType         : record?.reOrgType?.id,
			shortName         : record?.shortName?.trim() ?? null,
			shortNameBel      : record?.shortNameBel?.trim() ?? null,
			unp               : record?.unp ?? null
		}
		if (JSON.stringify(updateValues) === JSON.stringify(previousValues))
			Notifications.errorNotice(i18n.messageDataNotChanged[isRu], null, 20)
		else
			updateValues.id ? update(updateValues) : create(updateValues)
	}

	return (
		<Modal
			footer={ null }
			title={ record ? i18n.titleModalEditItem[isRu] : i18n.titleModalAddItem[isRu] }
			visible={ visible }
			width={ 1000 }
			onCancel={ handleCancel }
		>
			<Form
				form={ form }
				labelAlign="left"
				labelCol={ { span: 7 } }
				name="nsi-form"
				wrapperCol={ { offset : 1,
					span   : 16 } }
				onFinish={ onFinish }
			>
				<Form.Item
					label={ i18n.tableHeaderUNP[isRu] }
					name="unp"
					normalize={ (value) => (value ? value.trim() : value) }
					rules={ [
						({ getFieldValue }) => ({
							validator(_, value){
								if (!value || (/^([0-9]{9})$/).test(value))
									return Promise.resolve()
								return Promise.reject(i18n.unpError[isRu])
							}
						})
					] }
				>
					<CustomInput
						maxLength={ 10 }
						placeholder={ i18n.tableHeaderUNP[isRu] }
					/>
				</Form.Item>
				<Form.Item
					label={ i18n.tableHeaderType[isRu] }
					name="reOrgType"
					rules={ [{ required: true }] }
				>
					<CustomSelect
						allowClear
						showSearch
						defaultActiveFirstOption={ false }
						filterOption={ false }
						notFoundContent={ null }
						placeholder={ i18n.tableHeaderType[isRu] }
						showArrow={ false }
					>
						{ reOrgTypes?.map((value) => {
							return (
								<Select.Option
									key={ value.id }
									title={ isRu || !value.nameBel ? value.name : value.nameBel }
									value={ value.id }
								>
									{ isRu || !value.nameBel ? value.name : value.nameBel }
								</Select.Option>
							)
						}) }
					</CustomSelect>
				</Form.Item>
				<Form.Item
					label={ i18n.tableHeaderStatus[isRu] }
					name="reOrgStatusType"
					rules={ [{ required: true }] }
				>
					<CustomSelect
						allowClear
						showSearch
						defaultActiveFirstOption={ false }
						filterOption={ false }
						notFoundContent={ null }
						placeholder={ i18n.tableHeaderStatus[isRu] }
						showArrow={ false }
					>
						{ reOrgStatusTypes?.map((value) => {
							return (
								<Select.Option
									key={ value.id }
									title={ isRu || !value.nameBel ? value.name : value.nameBel }
									value={ value.id }
								>
									{ isRu || !value.nameBel ? value.name : value.nameBel }
								</Select.Option>
							)
						}) }
					</CustomSelect>
				</Form.Item>
				<Form.Item
					label={ i18n.tableHeaderFullNameRu[isRu] }
					name="fullName"
					rules={ [
						{
							max      : 900,
							min      : 5,
							required : true
						}
					] }
				>
					<Input.TextArea
						autoSize={ {
							maxRows : 4,
							minRows : 2
						} }
						maxLength={ 1000 }
						placeholder={ i18n.tableHeaderFullNameRu[isRu] }
					/>
				</Form.Item>
				<Form.Item
					label={ i18n.tableHeaderFullNameBel[isRu] }
					name="fullNameBel"
					rules={ [
						{
							max      : 900,
							min      : 5,
							required : false
						}
					] }
				>
					<Input.TextArea
						autoSize={ {
							maxRows : 4,
							minRows : 2
						} }
						maxLength={ 1000 }
						placeholder={ i18n.tableHeaderFullNameBel[isRu] }
					/>
				</Form.Item>
				<Form.Item
					label={ i18n.tableHeaderShortNameRu[isRu] }
					name="shortName"
					rules={ [
						{
							max      : 450,
							min      : 5,
							required : false
						}
					] }
				>
					<Input.TextArea
						autoSize={ {
							maxRows : 3,
							minRows : 1
						} }
						maxLength={ 500 }
						placeholder={ i18n.tableHeaderShortNameRu[isRu] }
					/>
				</Form.Item>
				<Form.Item
					label={ i18n.tableHeaderShortNameBel[isRu] }
					name="shortNameBel"
					rules={ [
						{
							max      : 450,
							min      : 5,
							required : false
						}
					] }
				>
					<Input.TextArea
						autoSize={ {
							maxRows : 3,
							minRows : 1
						} }
						maxLength={ 500 }
						placeholder={ i18n.tableHeaderShortNameBel[isRu] }
					/>
				</Form.Item>
				<Form.Item
					label={ i18n.tableHeaderParentOrg[isRu] }
					name="parentOrg"
					hidden={Boolean(reOrg)}
				>
					<CustomSelect
						allowClear
						showSearch
						filterOption={ false }
						getPopupContainer={ trigger => trigger.parentNode }
						notFoundContent={
							minReOrgSending ? <Spin size="small" /> : <Empty description={ i18n.orgSearchNotFound[isRu] } />
						}
						placeholder={ i18n.reOrgSearchPlaceholder[isRu] }
						style={ { height: "auto" } }
						onSearch={ (value) => {
							setParentName(value)
						} }
					>
						{ getReOrgOptions(minReOrgByNameOrUNP, "minReOrgByNameOrUNP") ?? getReOrgOptions(parentInit, "parentInitOrg")}
					</CustomSelect>
				</Form.Item>
				<Form.Item
					label={ i18n.tableHeaderInstitutionOrg[isRu] }
					name="institutionOrg"
					hidden={Boolean(reOrg)}
				>
					<CustomSelect
						allowClear
						showSearch
						filterOption={ false }
						getPopupContainer={ trigger => trigger.parentNode }
						notFoundContent={
							minReOrgSending ? <Spin size="small" /> : <Empty description={ i18n.orgSearchNotFound[isRu] } />
						}
						placeholder={ i18n.reOrgSearchPlaceholder[isRu] }
						style={ { height: "auto" } }
						onSearch={ (value) => {
							setInstitutionName(value)
						} }
					>
						{ getReOrgOptions(minReOrgByNameOrUNP, "minReOrgByNameOrUNP") ?? getReOrgOptions(institutionInit, "institutionInitOrg")}
					</CustomSelect>
				</Form.Item>
				{ Boolean(record) && (
					<Form.Item
						label={ i18n.tableHeaderIsEnteredManually[isRu] }
						name="isEnteredManually"
						valuePropName="checked"
						hidden={Boolean(reOrg)}
					>
						<Checkbox />
					</Form.Item>
				) }
				{
					Boolean(record?.reOrgCreator) && (
						<Form.Item
							label={ i18n.tableHeaderReOrgCreator[isRu] }
							name="reOrgCreator"
							hidden={Boolean(reOrg)}
						>
							<Input.TextArea readOnly autoSize/>
						</Form.Item>
					)
				}
				<Form.Item wrapperCol={ { span: 24 } }>
					<CustomButton
						htmlType="submit"
						loading={ isSending || changeOrgUnitLoading }
						type="orange"
					>
						{ i18nGlobal.save[isRu] }
					</CustomButton>
				</Form.Item>
			</Form>
		</Modal>
	)
}
export default ReOrgCreateUpdateForm
